import React from "react";
const trustItems = [{
  id: 1,
  text: "Fear-Free Certified"
}, {
  id: 2,
  text: "24/7 Monitoring"
}, {
  id: 3,
  text: "Advanced Tech"
}, {
  id: 4,
  text: "Compassionate Staff"
}];
export default function TheHappyPawsPromise() {
  return <section data-section-id="261182" id="the-happy-paws-promise" className="dark bg-muted text-foreground py-[100px] border-y border-border/50">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-6">
          {trustItems.map((item, i) => <div key={item.id} data-index={i} className="flex flex-col md:flex-row items-center justify-center md:justify-start gap-4 text-center md:text-left">
              <div className="w-3 h-3 bg-secondary rounded-lg shrink-0 shadow-sm" />
              <span className="font-default font-semibold text-sm md:text-base tracking-wide uppercase text-foreground/80">
                {item.text}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}